import React, { useEffect } from 'react'

import Divider from 'components_new/atoms/Divider'
import Switch from 'components_new/atoms/Switch'
import Text from 'components_new/atoms/Text'
import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useCustomer } from 'redux/hooks/Customer'
import { useTestEnvironment } from 'redux/hooks/TestEnvironment'
import { useTestEnvironmentActions } from 'redux/actions/TestEnvironment'

const TestEnvironmentToggle = () => {
  const accountSettings = useAccountSettings()
  const customer = useCustomer()
  const { variant, isInitialized } = useTestEnvironment()
  const { initializeTestEnvironment, updateTestEnvironment } =
    useTestEnvironmentActions()

  const accountId = accountSettings.account?.id

  useEffect(() => {
    if (!isInitialized && accountId) {
      initializeTestEnvironment(accountId)
    }
  }, [accountId, isInitialized, initializeTestEnvironment])

  if (!accountSettings.isAdmin) {
    return null
  }

  const testEnabled = (customer as { test_environment_enabled?: boolean })
    ?.test_environment_enabled

  if (!testEnabled) {
    return null
  }

  const checked = variant === 'test'

  return (
    <>
      <Divider sx={{ mb: 2, mt: 2 }} />
      <Text fontWeight="medium" fontSize={16} sx={{ mb: 1 }}>
        Testmiljö
      </Text>
      <SettingsGroup>
        <SettingsItem
          body="När testmiljön är på så används datan från test-miljön."
          icon={
            <Switch
              size="small"
              color="warning"
              checked={checked}
              onChange={() => {
                if (!accountId) return
                updateTestEnvironment(accountId, checked ? 'prod' : 'test')
                window.location.reload()
              }}
            />
          }
          title="Använd testmiljö"
        />
      </SettingsGroup>
    </>
  )
}

export default TestEnvironmentToggle
